import { FontWeights, memoizeFunction } from '@fluentui/react';

import { controlStylingConstants } from '@1js/acui-common';
import { AppLabelStyles } from '@1js/acui-label';

export const fontPickerLabelInMenuStyles = memoizeFunction(
  (hasIcon: boolean): AppLabelStyles => ({
    root: {
      marginLeft: hasIcon ? 10 : controlStylingConstants.menuNoIconGutterPadding,
      paddingLeft: 0,
      fontWeight: FontWeights.regular,
    },
  })
);
